<template>
  <div class="p-the-c01-form-note-panel-drink">
    <div class="p-the-c01-form-note-panel-drink__top">
      <IconBase :width="48" :height="68" view-box="0 0 48 68">
        <IconDrinkStop />
      </IconBase>
      <p class="p-the-c01-form-note-panel-drink__top__text">
        ※未成年者の飲酒は法律で禁止されています。
        <br />※飲酒は20歳になってから。飲酒運転は法律で禁止されています。
        <br />※妊娠中や授乳期の飲酒は、胎児・乳児の発育に悪影響を与える恐れがあります。
      </p>
    </div>
    <div class="p-the-c01-form-note-panel-drink__bottom">
      <InputCheckBox
        id="is_adult"
        name="is_adult"
        :value="value"
        @checked="onCheckAdult"
        >私は20歳以上です</InputCheckBox
      >
    </div>
  </div>
</template>

<script lang="ts">
import InputCheckBox from "@/common/components/atoms/InputCheckBox.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconDrinkStop from "@/common/components/icons/IconDrinkStop.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    value: { type: Boolean, required: true, default: false }
  },
  components: {
    InputCheckBox,
    IconBase,
    IconDrinkStop
  }
})
export default class TheC01ItemFormNotePanelDrink extends Vue {
  value!: boolean;

  onCheckAdult() {
    this.$emit("checked");
  }
}
</script>

<style lang="scss" scoped>
.p-the-c01-form-note-panel-drink {
  border: px(1) solid $common-gray-border;
  width: 100%;
  max-width: rem(592);

  &__top {
    @include text__body--s;
    padding: rem(16);
    display: flex;
    align-items: center;
    color: #828282;
    border-bottom: px(1) solid $common-gray-border;

    @include sp {
      align-items: flex-start;
    }

    &__text {
      margin-left: rem(16);
      flex: 1;
    }
  }

  &__bottom {
    padding: rem(4) 0 rem(4) rem(12);
  }
}
</style>
